import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import { fetchJSON } from "helpers/axios";
import { connect } from "react-redux";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -7,
    top: 3,
    fontSize: "10px",
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "2px",
  },
}))(Badge);

class StudentMenuList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationCounts: {
        lectureNotes: 0,
        assignments: 0,
        liveClassRoom: 0,
        learningDiscussion: 0,
        announcements: 0,
        exams: 0, // Added exams notification count
      },
    };
  }

  componentDidMount() {
    const { history, authUser } = this.props;
  
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function(event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
    if (authUser && authUser.StudId) {
      this.fetchAllNotifications();
    }
  }

  fetchAllNotifications = async () => {
    const { authUser } = this.props;
    if (!authUser || !authUser.StudId) return;

    const { StudId, token } = authUser;

    try {
      const notificationTypes = [
        { type: 2, key: "lectureNotes" },
        { type: 3, key: "assignments" },
        { type: 4, key: "liveClassRoom" },
        { type: 5, key: "learningDiscussion" },
        { type: 6, key: "announcements" },
        { type: 7, key: "exams" },
      ];

      // Create an array of promises to fetch all notification types concurrently
      const fetchPromises = notificationTypes.map(({ type, key }) =>
        this.fetchNotificationCount(StudId, token, type, key)
      );

      // Wait for all promises to resolve
      await Promise.all(fetchPromises);

      // Force a re-render after all notifications are fetched
      this.forceUpdate();
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  fetchNotificationCount = async (
    studId,
    token,
    notificationType,
    stateKey
  ) => {
    try {
      const response = await fetchJSON(
        `api/GetUnReadNotifications?staffId=${studId}&notificationType=${notificationType}`,
        null,
        "GET",
        token
      );

      if (response?.Status === true) {
        // Update the count for this notification type
        this.setState((prevState) => {
          console.log(
            `Updating ${stateKey} count:`,
            response?.Data?.length || 0
          ); // Add logging
          return {
            notificationCounts: {
              ...prevState.notificationCounts,
              [stateKey]: response?.Data?.length || 0,
            },
          };
        });
      }
    } catch (error) {
      console.error(`Error fetching ${stateKey} notifications:`, error);
    }
  };

  markNotificationsAsRead = async (notificationType) => {
    const { authUser } = this.props;
    if (!authUser || !authUser.StudId) return;

    const { StudId, token } = authUser;

    try {
      const response = await fetchJSON(
        `api/MarkNotificationsAsRead?staffId=${StudId}&notificationType=${notificationType}`,
        null,
        "POST",
        token
      );

      if (response?.Status === true) {
        // Update the count for this notification type to 0
        this.setState((prevState) => ({
          notificationCounts: {
            ...prevState.notificationCounts,
            [this.getKeyFromType(notificationType)]: 0,
          },
        }));
      }
    } catch (error) {
      console.error(`Error marking notifications as read:`, error);
    }
  };

  getKeyFromType = (type) => {
    const mapping = {
      2: "lectureNotes",
      3: "assignments",
      4: "liveClassRoom",
      5: "learningDiscussion",
      6: "announcements",
      7: "exams",
    };
    return mapping[type] || "";
  };


  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function(fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
    }, []);
  };

  renderMenuItemWithBadge = (to, icon, text, notificationType) => {
    const count =
      this.state.notificationCounts[this.getKeyFromType(notificationType)] || 0;

    return (
      <NavLink
        to={to}
        onClick={() => this.markNotificationsAsRead(notificationType)}
      >
        {count > 0 ? (
          <StyledBadge badgeContent={count} color="secondary">
            <i className={`zmdi ${icon} zmdi-hc-fw`} />
            <span className="nav-text">{text}</span>
          </StyledBadge>
        ) : (
          <>
            <i className={`zmdi ${icon} zmdi-hc-fw`} />
            <span className="nav-text">{text}</span>
          </>
        )}
      </NavLink>
    );
  };

  render() {
    const { studentPages } = this.props;

    const result = this.groupBy(studentPages, "Menu_Id");

    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.menu" />
          </li>
          <li className="menu no-arrow">
            <NavLink to="/student/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/profile">
              <i className="zmdi zmdi-account zmdi-hc-fw" />
              <span className="nav-text">Profile</span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/payment">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">School Fees</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/applyforhostel">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Apply for hostel</span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/courseregistration">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Courses</span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/liveclasses",
              "zmdi-graduation-cap",
              "Live Classes",
              4 // Notification type for live classes
            )}
          </li>
          <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/exams",
              "zmdi-graduation-cap",
              "Exams",
              7 // Notification type for exams
            )}
          </li>
          <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/lecturenote",
              "zmdi-graduation-cap",
              "Lecturer Note",
              2 // Notification type for lecture notes
            )}
          </li>
          <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/discussion",
              "zmdi-graduation-cap",
              "Discussion",
              5 // Notification type for learning discussion
            )}
          </li>
          <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/assignment",
              "zmdi-graduation-cap",
              "Assignment",
              3 // Notification type for learning discussion
            )}
          </li>

          <li className="menu no-arrow">
            <NavLink to="/student/changepassword">
              <i className="zmdi zmdi-key zmdi-hc-fw" />
              <span className="nav-text">Change Password</span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const authUser = auth.studentUser;
  return { authUser };
};
export default withRouter(connect(mapStateToProps, {})(StudentMenuList));
